import React, { FC } from 'react';

import clsx from 'clsx';
import styled from '@emotion/styled';
import { variant } from '@lucid/theme';

export type NavbarBorderVariants = 'default';

export interface NavbarBorderProps {
  /** Allows the component to get additional styles. */
  className?: string;
  /** Sets the component as hidden. */
  isHidden?: boolean;
  /** Sets the component to have a border line. */
  hasBorder?: boolean;
  /** Sets a box-shadow for the component. */
  hasShadow?: boolean;
  /** Changes the variant for the NavbarBorder component. */
  variant?: NavbarBorderVariants;
}

const StyledNavbarBorder: FC<NavbarBorderProps> = styled.div<NavbarBorderProps>(
  (
    { isHidden }
  ) => [
    {
      label: 'navbarBorder',
      flexBasis: '100%',
      order: 0,
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      opacity: 1,
      transition: 'opacity 0.2s ease-out 0s',
      visibility: isHidden ? 'hidden' : 'visible'
    },
    isHidden && {
      opacity: 0,
      visibility: 'hidden'
    }
  ],
  variant({
    scale: 'navbar.border',
    variants: {
      defaultVariant: {}
    }
  })
);

const NavbarBorderShadow = styled.div({
  height: '16px',
  marginTop: '-16px',
  opacity: 1,
  boxShadow: 'rgba(40, 44, 51, 0.2) 0px 4px 4px'
});

const NavbarBorder: FC<NavbarBorderProps> = ({
  className,
  isHidden,
  hasBorder = false,
  hasShadow = false,
  variant = 'default',
  ...rest
}) => (
  <StyledNavbarBorder
    {...rest}
    className={clsx(className, hasBorder && 'hasBorder')}
    isHidden={isHidden}
    variant={variant}
  >
    {hasShadow && <NavbarBorderShadow />}
  </StyledNavbarBorder>
);

export { NavbarBorder };
export default NavbarBorder;
